import { EverydaySlotsSelector } from 'common/entity/components/dayShift/WorkingDaysSelector';
import { DayShiftSlotsSelectorWithOffset } from 'common/entity/components/dayShift/DayShiftSlotsSelector';
import slotsSelectorFactory from 'common/entity/components/slot/SlotsSelectorFactory';

const WorkingDaysSelectorWithOffset = slotsSelectorFactory({
    MultiDayWeekSlotsSelector: DayShiftSlotsSelectorWithOffset,
    EverydaySlotsSelector
});

export { WorkingDaysSelectorWithOffset };
export default WorkingDaysSelectorWithOffset;
